export default __webpack_public_path__ + "static/Robert.EarleCHAIRFinance_social-d5cdc15445582fd52aa0bf5e5a4fc109.jpg";